import { useQuery } from '@tanstack/react-query';
import { Link } from 'react-router-dom';
import { api } from '../api';
import { formatPln } from '../catalog/money';
import { dayLabel, SETTLEMENTS_KEY, STATES, type Summary } from './types';

/** "Moje rozliczenia" in "Mój kalendarz" (F39, D16): the user's own settlements with amounts — it is their money. */
export function MySettlements() {
  const list = useQuery({ queryKey: [...SETTLEMENTS_KEY, 'mine'], queryFn: () => api<Summary>('/api/settlements?mine=1') });
  const rows = list.data?.rows ?? [];
  if (!list.data || rows.length === 0) return null;
  return (
    <section className="fin-section" aria-label="Moje rozliczenia" data-feature-id="settlements.list">
      <h2>Moje rozliczenia</h2>
      <div className="table-wrap">
        <table className="table fin-table">
          <thead>
            <tr>
              <th scope="col">Wydarzenie</th>
              <th scope="col">Stan</th>
              <th scope="col" className="num">
                Razem
              </th>
              <th scope="col" className="num">
                Do wypłaty
              </th>
            </tr>
          </thead>
          <tbody>
            {rows.map((r) => (
              <tr key={r.settlementId}>
                <td>
                  <Link to={`/finanse/rozliczenia/${r.settlementId}`}>
                    {dayLabel(r.eventFirstDay)} {r.eventName}
                  </Link>
                </td>
                <td>{STATES[r.state]}</td>
                <td className="num">{r.totalGrosze === undefined ? '—' : formatPln(r.totalGrosze)}</td>
                <td className="num">{r.dueGrosze === undefined ? '—' : formatPln(r.dueGrosze)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </section>
  );
}
